import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Step,
  Warning,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const LoadLists = () => (
  <Page
    title="Load Lists"
    intro="Load lists are the standards behind Make Ready: what a fully stocked vehicle, bag, or device should contain. Every Make Ready check compares the real contents against the load list assigned to that vehicle or asset."
  >
    <Section title="Where load lists live">
      <Bullets>
        <Bullet>
          Manage them from the <strong>Load Lists</strong> tab of{' '}
          <DocLink url="/make-ready-load-lists" text="Make Ready" /> (they
          are no longer under Site Configuration). The list shows how many
          vehicle lists and asset lists exist, and each can be opened,
          duplicated as a new list, or deleted.
        </Bullet>
        <Bullet>
          First time setting up? The <strong>Setup Wizard</strong> walks
          through creating your initial lists.
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        Viewing load lists requires the Fleet, Make Ready, Governance,
        Manager, or Supervisor team. Creating, editing, and deleting them
        requires the <strong>Governance</strong>, <strong>Manager</strong>,
        or <strong>Supervisor</strong> team (site administrators always
        can). Governance, Managers, and Supervisors also get{' '}
        <strong>Edit Load List</strong> shortcuts directly from a Make Ready
        check and from the Make Ready overview.
      </Info>
    </Section>

    <Section title="Building a list">
      <Step number={1} title="Start the list">
        Click <strong>Add New</strong>, give the list a title, and choose
        its type — a vehicle list or an asset list (bag, device, and so on).
        You can also start from a copy of an existing list instead of a
        blank page.
      </Step>
      <Step number={2} title="Add sections">
        Break the list into sections (for example, a cupboard or pouch).
        Within each section, add the required assets — chosen by category
        and sub-category, with a per-item setting for whether an expiry date
        must be recorded — and the required consumables with the quantity
        expected.
      </Step>
      <Step number={3} title="Save">
        Duplicate titles are flagged before saving, and a section can only
        be deleted once it is empty.
      </Step>
    </Section>

    <Section title="Assigning lists to vehicles and assets">
      <Bullets>
        <Bullet>
          The editor's <strong>Assigned To</strong> panel shows every
          vehicle and asset currently checked against the list, and lets you
          assign or unassign them right there — no need to hunt through the
          Asset Manager.
        </Bullet>
        <Bullet>
          A vehicle's list can also be set from the vehicle record (a
          flashing <strong>Not Set</strong> chip appears if it has none),
          and an asset's from its form in the Asset Manager.
        </Bullet>
      </Bullets>
      <Warning title="Deleting an assigned list">
        Deleting a list that vehicles or assets still point at removes Make
        Ready tracking from them — the delete confirmation names exactly
        which ones are affected, and they will need a new list assigned
        before they can be checked again.
      </Warning>
    </Section>
  </Page>
)

export default LoadLists
